module.exports = __webpack_public_path__ + "static/media/web01.90af38bc.png";